import Icon from '../../components/Icon.vue'

Icon.register({"brands/envira":{"width":448,"height":512,"paths":[{"d":"M0 32C477.6 32 366.6 349.3 367.1 398.3L448 480H422L351.6 408.8C312.6 413 227.2 443.3 137.2 371.8 47 300.3 52 214.7 0 32zM79.7 78C30 54.5 74.5 87.2 74.5 87.2 119.7 118.4 140.5 160.9 164.7 207.1 196.2 267.3 243.7 346.8 308.9 374.8 373.9 402.8 343.1 387.3 314.9 366.3 286.7 345.1 246.7 279.3 223.9 236.1 192.2 176.1 162.9 117.5 79.7 78z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/brands/envira.js